var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"masonry",style:({'--masonry-cols': _vm.columns, '--masonry-width': _vm.width, '--masonry-gap': _vm.gap})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }